import Header from "../components/navbar/Header";
import Footer from "../components/footer/Footer";
import { Link } from "react-router-dom";

// Import all SVG award files
import awardSvg1 from "../assets/awards/1.svg";
import awardSvg2 from "../assets/awards/2.svg";
import awardSvg3 from "../assets/awards/3.svg";
import awardSvg4 from "../assets/awards/4.svg";
import awardSvg5 from "../assets/awards/5.svg";
import awardSvg6 from "../assets/awards/6.svg";

import awardSvg8 from "../assets/awards/8.svg";
import awardSvg9 from "../assets/awards/9.svg";
import awardSvg10 from "../assets/awards/10.svg";
import awardSvg11 from "../assets/awards/11.svg";
import awardSvg12 from "../assets/awards/12.svg";
import awardSvg13 from "../assets/awards/13.svg";
import awardSvg14 from "../assets/awards/14.svg";

function Awards() {

  const awards = [
     awardSvg1,
    awardSvg2,
    awardSvg3,
    awardSvg4,
    awardSvg5,
    awardSvg6,
    awardSvg8,
    awardSvg9,
    awardSvg10,
    awardSvg11,
    awardSvg12,
    awardSvg13,
    awardSvg14,
    // JPEG Awards
    require("../assets/awards/1.jpeg"),
    require("../assets/awards/2.jpeg"),
    require("../assets/awards/3.jpeg"),
    require("../assets/awards/4.jpeg"),
    require("../assets/awards/5.jpeg"),
    require("../assets/awards/6.jpeg"),
    require("../assets/awards/7.jpeg"),
    require("../assets/awards/8.jpeg"),
    require("../assets/awards/9.jpeg"),
    require("../assets/awards/10.jpeg"),
    require("../assets/awards/11.jpeg"),
    require("../assets/awards/12.jpeg"),
    require("../assets/awards/13.jpeg"),
    require("../assets/awards/14.jpeg"),

   
   
  ];

  return (
    <>
      <Header />

      {/* Banner */}
      <img
        src={require("../assets/banners/1.webp")}
        className="w-full lg:h-[650px] object-cover"
        alt="Awards Banner"
        loading="lazy"
      />

      {/* Breadcrumb */}
      <div className="shadow sm:px-0 px-4">
        <p className="container mx-auto py-4">
          <Link to="/">Home</Link> / Awards
        </p>
      </div>

      {/* Awards Grid */}
      <div className="container mx-auto py-16 px-5">
        <p className="text-red-500 font-semibold mb-8 md:text-3xl text-center">
          Awards
        </p>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {awards.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Award ${index + 1}`}
              loading="lazy"
              className="h-[300px] w-full object-contain bg-white rounded-lg shadow"
            />
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Awards;
